/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Section_TooltipInputs */

const fr_copy_section_tooltip = /** @type {(inputs: Copy_Section_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier cette section`)
};

/**

* @param {Copy_Section_TooltipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const copy_section_tooltip = /** @type {((inputs?: Copy_Section_TooltipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Section_TooltipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_copy_section_tooltip(inputs)
});